export const openVideo = (navigate, language, video) => {
  navigate(`/${language}/video/${video.id}`, {
    state: { video },
  });
};
